export const RECAPTCHA_SITE_KEY = "6Lf8SfwUAAAAANqqESztPk-IFU2VIxXuK4eZwQdH"